import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Col, Row } from 'react-flexbox-grid';
import Button from 'antd/lib/button';

const SelectAllocationType = ({ selectManualAllocation, selectAutomaticAllocation, autoinvest,t }) => (
  <section className="panel-wrapper select-allocation-type">
    <h2>{t('Nastavenie investícií')}</h2>
    <Row>
      <Col >
        <p style={{textAlign: 'center', marginBottom:10+'px'}}>
          V systéme Maják vždy
          investujete do celej pôžičky. Do pôžičiek môžete investovať zadaním autoinvestu, pri
          ktorom si zvolíte požadovanú minimálnu výnosnosť a maximálnu dobu splatnosti alebo
          manuálne výberom konkrétnych pôžičiek, do ktorých máte záujem investovať.
        </p>
      </Col>
      
    </Row>
    <Row>
      <Col xs={12} sm={4} smOffset={1}>
        <Button onClick={selectAutomaticAllocation} type="primary" className="btn-block">
          {t('Automatické investovanie')}
        </Button>
        {autoinvest && autoinvest.status === 'ON' ? <p style={{color: 'green', textAlign: 'center', fontWeight: 'bold'}}>{t('Autoinvest je aktívny')}</p> : <p style={{color: 'red', textAlign: 'center', fontWeight: 'bold'}}>{t('Autoinvest nie je aktívny')}</p>}
        
        {autoinvest && autoinvest.status === 'ON' ? <p style={{fontStyle: 'italic', textAlign: 'center'}}>
          {t(
            'Váš autoinvest je aktívny a v zmysle Vašich zadaných požiadaviek investuje do dostupných pôžičiek.'
          )}
        </p> :
        <p style={{fontStyle: 'italic', textAlign: 'center', fontSize: 12+'px'}}>
          {t(
            `Váš autoinvest nie je aktívny. Spustite si ho, aby
            Vám neunikla žiadna výhodná možnosť investovania do pôžičiek. Zvoliť si tiež
            môžete požadovaný minimálny výnos a maximálnu dobu splatnosti. Autoinvest
            si môžete kedykoľvek v budúcnosti vypnúť bez obmedzenia. 
            `
          )}
        </p>
        
        }
        
      </Col>
      <Col xs={12} sm={4} smOffset={2}>
        <Button onClick={selectManualAllocation} className="btn-secondary btn-block">
          {t('Manuálne investovanie')}
        </Button>
        <p style={{textAlign: 'center'}}>
          {t(
            'K dispozícii budete mať zoznam dlžníkov na základe ktorého si budete môcť vybrať, kam investovať.'
          )}
        </p>
      </Col>
    </Row>
  </section>
);

SelectAllocationType.propTypes = {
  t: PropTypes.func.isRequired,
  selectManualAllocation: PropTypes.func.isRequired,
  selectAutomaticAllocation: PropTypes.func.isRequired,
};

export default translate()(SelectAllocationType);



// WEBPACK FOOTER //
// ./src/features/allocations/components/SelectAllocationType.js